import React, { useEffect, useState } from "react";
import { SideMenuPage, WebArea, WebRoute } from "@intech/web-ui";
import { Session } from "@intech/react-service";

import { routes, headerRoutes } from "@routes";
import packageJson from "@root/package.json";
import config from "@src/config.json";

import "./index.scss";
import { useHistory } from "react-router-dom";
import { UsuarioService, LGPDService, VersionService, DadosPessoaisService } from "@services";
import { AxiosError } from "axios";

interface IProps {
  title?: string;
}

const MasterPage: React.FC<IProps> = ({ title, ...rest }) => {
  const history = useHistory();

  const [VersaoAPI, setVersaoAPI] = useState<string>("");
  const [nome, setNome] = useState("");
  const [admin, setAdmin] = useState(false);
  const [Routes, setRoutes] = useState<WebRoute[]>([]);

  useEffect(() => {
    (async () => {
      const versaoAPI = await VersionService.Buscar();
      setVersaoAPI(versaoAPI);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const menu = await UsuarioService.Menu();

        const navbarRoutesList = [];

        for (const route of routes) {
          if (menu.includes(route.id) && route instanceof WebRoute) {
            navbarRoutesList.push(route);
          }
          if (menu.includes(route.id) && route instanceof WebArea) {
            let area = Object.assign<WebArea, any>(new WebArea(), route);
            area.routes = [];
            for (let areaRoute of route.routes) {
              if (menu.includes(areaRoute.id)) {
                area.routes.push(areaRoute);
              }
            }
            navbarRoutesList.push(area);
          }
        }

        setRoutes(navbarRoutesList);
      } catch (e) {
        const err = e as AxiosError;
        console.error(err.response ? err.response.data : err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        var token = await localStorage.getItem(`@${config.appName}:token`);

        if (token) {
          const admin = await UsuarioService.VerificarAdmin();

          // const NaoParticipante = await UsuarioService.VerificarNaoParticipante();

          // if (NaoParticipante && admin) {
          //   setAdmin(admin);
          //   return;
          // }

          var termo = await LGPDService.Buscar();

          if (!termo && !admin) {
            history.push("/termos");
          } else {
            const usuario = await UsuarioService.Buscar();

            if (usuario.USR_SENHA_NOVA !== "N" && !admin) {
              history.push("/trocarSenhaPrimeiroAcesso");
            } else {
            }

            const dados = await DadosPessoaisService.Buscar();
            const nomeUsuario = dados.NO_PESSOA;

            setNome(nomeUsuario);
            setAdmin(admin);
          }
        } else {
          await Session.clear();
          history.push("/login");
        }
      } catch (e) {
        const err = e as AxiosError;
        if (err.message.indexOf("401") > -1) {
          await Session.clear();
          history.push("/login");
        } else {
          alert("Ops! Ocorreu um erro ao processar sua requisição.");
          console.error(err);
        }
      }
    })();
  }, [history]);

  return (
    <SideMenuPage
      admin={admin}
      loading={false}
      logo={require("../../assets/logo.png")}
      routes={Routes}
      userComponent={null}
      username={nome}
      version={`Portal v${packageJson.version} API v${VersaoAPI}`}
      title={title}
      headerRoutes={headerRoutes}
      stickyHeader={true}
      {...rest}
    />
  );
};

export default MasterPage;
